import React from 'react';
import cx from 'classnames';
import { useForm } from 'react-hook-form';
import { Input } from '../../Input';
import endpoints from '../../../define/endpoints';
import { useAuth0 } from '../../../context/auth0';
import { TRANSLATIONS } from '../../../../translations';
import {
  trackNewsletterToggle,
  NEWSLETTER_SOURCES,
} from '../../../utils/posthogTracking';

const CustomerSignupForm = ({ onSubmit, auth0Google, auth0Facebook, auth0Apple, alertMessage }) => {
  const { handleSubmit, register, errors } = useForm();
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const isSpanishEnv = freedomeConfig.baseLocale === 'es';
  const handlePrivacyClick = () => {
    document.getElementById('iubenda-privacy-trigger').click();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
      <p className={'text-center'}>{app_main_wpml.create_account}</p>

      {!!alertMessage && (
        <div className="Alert__message--error modal-alert">
          <span>
            {app_main_wpml.cannot_complete_subscription};{' '}
            {app_main_wpml.if_account_yet}{' '}
            <a
              onClick={() => {
                isAuthenticated ? null : loginWithRedirect();
              }}
            >
              {app_main_wpml.login.toLowerCase()}
            </a>
            , {app_main_wpml.if_need_help}{' '}
            <a href={app_main_wpml.contacts_link} target="_blank">
              {app_main_wpml.contact_us}
            </a>
          </span>
        </div>
      )}

      <div className={'login'}>
        <span onClick={auth0Google} className={cx('btn', 'login__btn')}>
          <img
            src={`${endpoints.bucket}icons/logo-google-g.svg`}
            alt="Logo Google"
          />
          {app_main_wpml.continue_with_google}
        </span>
        <span onClick={auth0Facebook} className={cx('btn', 'login__btn')}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="#0866ff">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
          {app_main_wpml.continue_with_facebook}
        </span>
        <span onClick={auth0Apple} className={cx('btn', 'login__btn')}>
          <svg fill="black" height="20" width="20" viewBox="0 0 22.773 22.773" style={{ marginBottom: '2px' }}>
            <path d="M15.769,0c0.053,0,0.106,0,0.162,0c0.13,1.606-0.483,2.806-1.228,3.675c-0.731,0.863-1.732,1.7-3.351,1.573 c-0.108-1.583,0.506-2.694,1.25-3.561C13.292,0.879,14.557,0.16,15.769,0z"></path> <path d="M20.67,16.716c0,0.016,0,0.03,0,0.045c-0.455,1.378-1.104,2.559-1.896,3.655c-0.723,0.995-1.609,2.334-3.191,2.334 c-1.367,0-2.275-0.879-3.676-0.903c-1.482-0.024-2.297,0.735-3.652,0.926c-0.155,0-0.31,0-0.462,0 c-0.995-0.144-1.798-0.932-2.383-1.642c-1.725-2.098-3.058-4.808-3.306-8.276c0-0.34,0-0.679,0-1.019 c0.105-2.482,1.311-4.5,2.914-5.478c0.846-0.52,2.009-0.963,3.304-0.765c0.555,0.086,1.122,0.276,1.619,0.464 c0.471,0.181,1.06,0.502,1.618,0.485c0.378-0.011,0.754-0.208,1.135-0.347c1.116-0.403,2.21-0.865,3.652-0.648 c1.733,0.262,2.963,1.032,3.723,2.22c-1.466,0.933-2.625,2.339-2.427,4.74C17.818,14.688,19.086,15.964,20.67,16.716z"></path>
          </svg>
          {app_main_wpml.continue_with_apple}
        </span>

        <p className={'text-center'}>
          <small>{app_main_wpml.register_via_email}</small>
        </p>

        <Input
          className={cx('input__modal')}
          shadowed
          label={app_main_wpml.first_name}
          name="first_name"
          setRef={register({ required: true, max: 1000 })}
        />

        <Input
          className={cx('input__modal')}
          shadowed
          label={app_main_wpml.last_name}
          name="last_name"
          setRef={register({ required: true, max: 1000 })}
        />

        <Input
          className={cx('input__modal')}
          shadowed
          label={app_main_wpml.Email}
          name="email"
          setRef={register({
            required: true,
            max: 1000,
            pattern: /^\S+@\S+$/i,
          })}
        />

        <Input
          className={'input__modal'}
          shadowed
          label={TRANSLATIONS.PASSWORD}
          type="password"
          name="password"
          errored={!!errors['password']}
          setRef={register({
            required: true,
            pattern: { value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/ },
          })}
        />
        <small className="hint">{app_main_wpml.password_check}</small>

        <div
          className={cx('fake-checkbox')}
          style={{ marginLeft: 5, marginTop: 5 }}
        >
          <input
            className="fake-checkbox__input"
            type="checkbox"
            name="newsletter"
            ref={register()}
            id="customer-signup-newsletter"
            onChange={(e) =>
              trackNewsletterToggle(
                e.target.checked,
                NEWSLETTER_SOURCES.SIGNUP_MODAL
              )
            }
          />
          <label
            htmlFor="customer-signup-newsletter"
            className="fake-checkbox__label"
          >
            <span class="iconify inline" data-icon="mdi:check-bold"></span>
          </label>
          <p className="fake-checkbox__text">
            {isSpanishEnv ? app_main_wpml.newsletter_subscription_es : app_main_wpml.newsletter_subscription}
          </p>
        </div>

        <div
          className={cx('fake-checkbox', {
            'fake-checkbox--errored': !!errors.privacy,
          })}
          style={{ marginLeft: 5, marginTop: 5 }}
        >
          <input
            className="fake-checkbox__input"
            type="checkbox"
            name="privacy"
            ref={register({ required: true })}
            id="customer-signup-privacy"
          />
          <label
            htmlFor="customer-signup-privacy"
            className="fake-checkbox__label"
          >
            <span class="iconify inline" data-icon="mdi:check-bold"></span>
          </label>
          <p className="fake-checkbox__text">
            {app_main_wpml.privacy_acceptance}{' '}
            <span className="fake-checkbox__link" onClick={handlePrivacyClick}>
              Privacy Policy
            </span>
          </p>
        </div>
      </div>

      <button type="submit" className="btn btn--primary btn--expanded">
        {app_main_wpml.signup}
      </button>
    </form>
  );
};

export default CustomerSignupForm;
